module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_aq_pre.e2faca7e.png";